export const CREATE_DELETE_USERS = 'createDeleteUsers';
export const ADMIN_USERS = 'adminUsers';
export const ADMIN_PAGES = 'adminPages';
